import './index.css'
import React from 'react'
import Flex from 'components/Flex'
import ProductVariantCarouselInfo from 'pages/Squad/containers/ProductVariantCarouselInfo'
import hasVariantByIdInCartSelector from 'modules/cart/redux/selectors/has-variant-by-id-in-cart'
import useSelector from 'hooks/use-selector'
import logUtil from 'utils/log'
import useDispatch from 'hooks/use-dispatch'
import CheckmarkIcon from 'components/Icons/Checkmark'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import getByVariantIdAddLabelSelector from 'modules/product/redux/selectors/get-by-variant-id-add-label'
import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import getGiftCardItemCartSelect from 'modules/cart/redux/selectors/get-gift-card'
import { GIFT_CARD_PRODUCT_VARIANT } from 'modules/gift/constants'
import openQuickShopSidebarProductAction from 'modules/product/redux/actions/open-quick-shop-product-sidebar'
import shouldFlattenSamplesUrlLocationUtil from 'utils/location/should-flatten-samples'
import openUnlockTierProductSidebarGiftAction from 'modules/product/redux/actions/open-unlock-tier-sidebar'
import isFreeSampleVariantUtil from 'modules/variant/utils/is-free-sample'
import getLoyaltyTierNameProductVariantUtil from 'modules/gift/utils/get-loyalty-tier-name'
import isUnlockedProductVariantSelector from 'modules/product/redux/selectors/is-unlocked'
import useIsSmallScreen from 'hooks/use-is-small-screen'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import getDiscountPercentageFromVariantInfoSelector from 'modules/variant/redux/selectors/get-discount-percentage-from-variant-info'
import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import getQuickShopHrefProductVariantUtil from 'modules/product-variant/utils/get-quick-shop-href'
import getDiscountDataSelectorProductCollectionItemSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-discount-data'
import isDisabledByIdVariantSelector from 'modules/variant/redux/selectors/is-disabled-by-id'
import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'
import logEventWithPrefixAnalyticsUtil from 'utils/analytics/log-event-with-prefix'
import getPriceProductVariantUtil from 'modules/product-variant/utils/get-price'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'
import isSampleVariantUtil from 'modules/variant/utils/is-sample'
import needsToBeRatedProductSelector from 'modules/product/redux/selectors/needs-to-be-rated'
import ProductCollectionItemCardLoad from 'containers/ProductCollection/components/Item/components/Load'
import isFullSizeFromConversionOutOfStockSelector from 'containers/ProductCollection/components/Item/redux/selectors/is-full-size-from-conversion-out-of-stock'
import ProductCollectionItemLoadFullSizeConversion from 'containers/ProductCollection/components/LoadFullSizeProductVariant'
import getSampleOrFullSizeProductVariantSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-sample-or-full-size-product-variant'
import getImageToDisplayOnCardSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-image-to-display-on-card'
import getSelectedVariantIdSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-selected-variant-id'
import LoadFullSizeVariantToBeRated from 'containers/ProductCollection/components/Item/components/LoadFullSizeVariantToBeRated'
import isOutOfStockProductVariantUtil from 'modules/variant/utils/is-product-variant-out-of-stock'
import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'
import wasNotDeliveredSelector from 'modules/product/redux/selectors/was-not-delivered'
import isProductUrlLocationUtil from 'utils/location/is-product-url'
import scrollToTopDomUtil from 'utils/dom/scroll-to-top'
import updateHandleUrlProductUtil from 'modules/product/utils/update-handle-url'
import getImageUrlProductCollectionItemSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-image-url'
import shouldShowQuickShadesProductVariantSelector from 'modules/product-variant/redux/selectors/should-show-quick-shades'
import getSelectedQuickShadeVariantIdSelector from 'modules/variant/redux/selectors/get-selected-quick-shade-variant-id'
import shouldShowFullSizeConversionVariantSelector from 'modules/product/redux/selectors/should-show-full-size-conversion'
import handleClickAddButtonProductCollectionItemAction from 'containers/ProductCollection/components/Item/redux/actions/handle-click-add-button'
import useIsExtraExtraSmallScreen from 'hooks/use-is-extra-extra-small-screen'
import ProductCollectionItemButton from 'containers/ProductCollection/components/Item/components/Button'
import openAddFullSizeAfterRatingModalProductionAction from 'modules/product/redux/actions/open-add-full-size-after-rating-modal'
import getCompareAtPriceProductVariantUtil from 'modules/product-variant/utils/get-compare-at-price'
import getRawPriceProductVariantUtil from 'modules/product-variant/utils/get-raw-price'

const SIDEBAR_TITLE = 'Quick shop'

const ANALYTICS_EVENT = {
  VIEW_PRODUCT_CARD: 'VIEW_PRODUCT_CARD',
  UNLOCK_PRODUCT_CARD: 'UNLOCK_PRODUCT_CARD',
  UNLOCK_PRODUCT_BUTTON: 'UNLOCK_PRODUCT_BUTTON',
  VIEW_PRODUCT_OPTIONS: 'VIEW_PRODUCT_OPTIONS',
  NAVIGATE_TO_RATE_SAMPLED_VARIANT_FROM_COLLECTION: 'NAVIGATE_TO_RATE_SAMPLED_VARIANT_FROM_COLLECTION'
}

/**
 *
 * @param {ProductCollectionItemProps} props
 * @constructor
 */
const ProductCollectionItem = (props) => {
  /**
   * @type {ProductVariantCollection}
   */
  const featuredProductVariant = props.productVariant
  const featuredVariantId = featuredProductVariant.variant_id
  const variants = getVariantsProductVariantUtil(featuredProductVariant)
  const isExtraExtraSmallScreen = useIsExtraExtraSmallScreen()

  const shouldShowQuickShades = useSelector(
    shouldShowQuickShadesProductVariantSelector({
      featuredProductVariant,
      isExtraExtraSmallScreen
    })
  )
  const selectedQuickShadeVariantId = useSelector(
    getSelectedQuickShadeVariantIdSelector(featuredVariantId)
  )
  let variantId = (
    selectedQuickShadeVariantId ||
    featuredVariantId
  )

  /**
   * @type {ProductVariantCollection}
   */
  let productVariant
  if (selectedQuickShadeVariantId) {
    productVariant = variants?.find(variant => variant.variant_id === selectedQuickShadeVariantId)
  }
  productVariant = productVariant || featuredProductVariant

  const productVariantDeep = useSelector(
    getByVariantIdDeepProductSelector(
      productVariant?.fullsize_variant_id
    )
  )

  const productId = productVariant?.product_id
  const isFullSizeVariant = isFullSizeVariantUtil(productVariant)

  /**
   * we are checking product level statuses
   * because it might be possible that the variant
   * we are showing on the card is not the one that user has sampled
   * and we should also make sure that it should not be full size
   */
  const checkVariantStatus = (variantSelector) => (
    useSelector(variantSelector(productId)) &&
    !isFullSizeVariant
  )
  const needsToBeRatedSample = checkVariantStatus(needsToBeRatedProductSelector)
  const wasNotDelivered = checkVariantStatus(wasNotDeliveredSelector)

  const shouldShowFullSizeConversion = useSelector(
    shouldShowFullSizeConversionVariantSelector({
      productVariant: featuredProductVariant,
      productId
    })
  )

  /**
   * we are storing the product variant passed through props
   * because we will need it later when we are loading the full size product variant
   * and also because the product variant passed through props might be a sample variant
   */
  const productVariantSample = productVariant
  productVariant = useSelector(
    getSampleOrFullSizeProductVariantSelector(
      {
        productVariantSample,
        shouldShowFullSizeConversion
      })
  )
  variantId = productVariant?.variant_id

  /**
   * Here we are checking if the full size from conversion is out of stock
   * that will be loaded inside the full size modal
   */
  const isOutOfStock = useSelector(
    isFullSizeFromConversionOutOfStockSelector({ productVariant })
  )

  const productVariantImage = useSelector(
    getImageToDisplayOnCardSelector(
      { productVariantSample }
    )
  )

  const selectedVariantId = useSelector(
    getSelectedVariantIdSelector(
      {
        productVariantSample,
        shouldShowFullSizeConversion
      }
    )
  )

  const isFullSize = (
    props.isFullSize ||
    isFullSizeVariantUtil(productVariant)
  )

  const isSample = isSampleVariantUtil(productVariant)
  const {
    analyticEventPrefix
  } = props
  const isInCart = useSelector(
    hasVariantByIdInCartSelector(variantId)
  )
  // const [isLoading, setIsLoading] = React.useState()
  const dispatch = useDispatch()
  const giftCardItem = useSelector(getGiftCardItemCartSelect)
  const isGiftCard = productVariant?.variant_id === GIFT_CARD_PRODUCT_VARIANT.variant_id
  const isSelfGifting = isSelfGiftingUrlLocationUtil()
  const productLoyaltyTierName = isSelfGifting
    ? null
    : getLoyaltyTierNameProductVariantUtil(productVariant)
  const isUnlocked = useSelector(
    isUnlockedProductVariantSelector({ productVariant })
  )
  const shouldUnlock = isSelfGifting
    ? false
    : !isUnlocked
  const isSmallScreen = useIsSmallScreen()
  const hasVariants = !!variants?.length
  const disabled = useSelector(
    isDisabledByIdVariantSelector({
      productVariant,
      isGiftCard
    })
  )

  const hasSampled = useSelector(
    hasSampledVariantSelector(featuredVariantId)
  )

  const price = getPriceProductVariantUtil(productVariant)
  const compareAtPrice = getCompareAtPriceProductVariantUtil({ variant: productVariant })
  const rawPrice = getRawPriceProductVariantUtil(productVariant)

  const shouldFlattenSamples = (
    !isFullSize &&
    shouldFlattenSamplesUrlLocationUtil()
  )
  const imageUrl = useSelector(
    getImageUrlProductCollectionItemSelector({
      shouldFlattenSamples,
      productVariantImage,
      variantId: featuredVariantId,
      variants
    })
  )
  const discountPercentage = useSelector(
    getDiscountPercentageFromVariantInfoSelector({
      variantId: productVariant?.variant_id
    })
  )

  /**
   * if the product is full size, and there are full size variants available, then we should show "View options"
   * if the product is not full size, and there are sample variants available, then we should show "View options"
   */
  const fullSizeVariants = variants?.filter(variant => isFullSizeVariantUtil(variant))
  const sampleVariants = variants?.filter(variant => isSampleVariantUtil(variant))
  const shouldShowVariants = isFullSize
    ? fullSizeVariants?.length > 0
    : sampleVariants?.length > 0

  const isQuestionProduct = props?.isQuestionProduct
  const variantToPass = isQuestionProduct
    ? productVariantDeep
    : productVariant

  const isProductVariantOutOfStock = isOutOfStockProductVariantUtil({
    productVariant: variantToPass,
    shouldShowVariants,
    isGiftCard,
    shouldShowQuickShades
  })

  const isJustDroppedSlider = props?.isJustDroppedSlider
  const wasJustDropped = (
    props?.wasJustDropped ||
    productVariant?.just_dropped
  )

  const {
    isOnlyAtAirshopDiscount,
    discountPrice,
    discountPercentage: discountPercentageToPass
  } = useSelector(
    getDiscountDataSelectorProductCollectionItemSelector({
      discountPercentage,
      isFullSize,
      price,
      productVariant,
      discountPrice: props.discountPrice,
      isCard: true
    })
  )

  const label = useSelector(
    getByVariantIdAddLabelSelector({
      variantId,
      featuredProductVariant,
      // isLoading,
      productVariant,
      isGiftCard,
      isFromGrid: true,
      isSmallScreen,
      disabled,
      shouldShowVariants,
      needsToBeRatedSample
    })
  )

  const shouldShowOutOfStockLabel = (
    props?.isArchived ||
    isProductVariantOutOfStock ||
    false
  )

  const isDisabled = (
    hasSampled &&
    wasNotDelivered &&
    !shouldShowVariants
  ) || shouldShowOutOfStockLabel

  const shouldLog = productVariant?.product_id === 8840984821980
  const debugProps = {
    isProductVariantOutOfStock,
    isDisabled,
    shouldShowOutOfStockLabel,
    shouldShowVariants,
    shouldShowFullSizeConversion,
    selectedQuickShadeVariantId,
    productVariantSample,
    discountPercentage,
    productVariant
  }
  shouldLog && logUtil('ProductCollectionItem').debug('debugProps=', debugProps)
  // const debugProps = {
  //   variantId,
  //   productVariant,
  //   props,
  //   shouldUnlock,
  //   discountPrice,
  //   shouldShowOutOfStockLabel,
  //   shouldShowVariants,
  //   variants
  // }

  const logPrefix = `variantId=${variantId}`
  // logUtil('ProductCollectionItem').debug(`${logPrefix} debugProps=`, debugProps)

  const logEvent = (event) => {
    return logEventWithPrefixAnalyticsUtil(analyticEventPrefix, event)
  }

  const updateCurrentProduct = async (props = {}) => {
    logUtil('ProductCollectionItem#updateCurrentProduct').debug(`${logPrefix} props=`, props)
    logUtil('ProductCollectionItem#updateCurrentProduct').debug(`${logPrefix} productVariant=`, productVariant)

    const productId = featuredProductVariant.product_id
    const variantId = shouldShowFullSizeConversion
      ? productVariant?.fullsize_variant_id
      : featuredProductVariant.variant_id

    dispatch(updateCurrentProductIdAction(productId))
    dispatch(updateCurrentVariantIdAction(variantId))

    const shouldSetProduct = props?.shouldSetProduct ?? true
    if (!shouldSetProduct) {
      return
    }

    // TODO migrate to util
    const handle = productVariant?.handle
    if (handle && isProductUrlLocationUtil()) {
      logUtil('ProductCollectionItem#updateCurrentProduct').debug(`${logPrefix} adding handle to url`)
      updateHandleUrlProductUtil({ handle })
    }

    addProductAndVariantIdToUrlProductUtil({
      productId,
      variantId
    })
  }

  const openProductSidebar = async (currentProps = {}) => {
    const beforeOpenSidebar = props?.beforeOpenSidebar
    if (beforeOpenSidebar) {
      beforeOpenSidebar()
    }

    updateCurrentProduct()

    // if pdp screen don't open the sidebar
    const isPdpScreen = isProductUrlLocationUtil()
    if (isPdpScreen) {
      logUtil('ProductCollectionItem#openProductSidebar').debug(`${logPrefix} [noop] pdp screen`)
      scrollToTopDomUtil()
      return
    }

    const selectedVariantIdToPass = (
      selectedQuickShadeVariantId ||
      selectedVariantId ||
      variantId
    )

    dispatch(
      openQuickShopSidebarProductAction({
        title: SIDEBAR_TITLE,
        isGifting: false,
        isFreeSample: isFreeSampleVariantUtil(productVariant),
        isFullSize,
        isSample,
        isJustDroppedSlider,
        selectedVariantId: selectedVariantIdToPass,
        featuredVariantId,
        ...currentProps
      })
    )
  }

  const openUnlockTierSidebar = () => {
    updateCurrentProduct({ shouldSetProduct: false })
    dispatch(
      openUnlockTierProductSidebarGiftAction({
        title: `Unlock ${productLoyaltyTierName} tier`,
        isGifting: false
      })
    )
  }

  const handleClick = async (event) => {
    event.preventDefault()

    if (props?.isArchived) {
      return
    }

    if (shouldUnlock) {
      logEvent(ANALYTICS_EVENT.UNLOCK_PRODUCT_CARD)
      openUnlockTierSidebar()
      return
    }

    logEvent(ANALYTICS_EVENT.VIEW_PRODUCT_CARD)

    openProductSidebar({
      beforeOnClickAdd: props?.beforeOnClickAdd,
      shouldHideVariantButtons: props.shouldHideVariantButtons
    })
  }

  const handleClickAddButton = async (e) => {
    return dispatch(
      handleClickAddButtonProductCollectionItemAction({
        e,
        logPrefix,
        shouldUnlock,
        isDisabled,
        openUnlockTierSidebar,
        logEvent,
        hasVariants,
        shouldShowQuickShades,
        shouldShowVariants,
        isInCart,
        props,
        variantId,
        productVariant,
        analyticEventPrefix,
        shouldShowFullSizeConversion,
        openProductSidebar
      })
    )
  }

  const handleOpenAddFullSizeModal = () => {
    logUtil('ProductCollectionItem#handleOpenAddFullSizeModal').debug(`${logPrefix} [start]`)

    if (isOutOfStock) {
      logUtil('ProductCollectionItem#handleOpenAddFullSizeModal').debug(`${logPrefix} [noop] full size is out of stock`)
      return
    }

    dispatch(
      openAddFullSizeAfterRatingModalProductionAction({
        imageUrl: productVariantImage,
        productVariant
      })
    )
  }

  // let onClickToPass
  // if (isLoading) {
  //   onClickToPass = noopFunctionUtil
  // } else {
  //   onClickToPass = handleClickAddButton
  // }
  const onClickToPass = handleClickAddButton

  let iconElement
  if (
    isInCart ||
    (
      isGiftCard &&
      giftCardItem
    )
  ) {
    iconElement = (
      <CheckmarkIcon />
    )
  }

  const buttonsProps = {
    disabled,
    iconElement,
    isDisabled,
    label,
    needsToBeRatedSample,
    onClickToPass,
    productId,
    productVariant,
    variantId,
    handleOpenAddFullSizeModal,
    shouldShowOutOfStockLabel
  }

  return (
    <Flex
      className='product-collection-item'
    >
      <LoadFullSizeVariantToBeRated
        productVariant={productVariant}
        needsToBeRatedSample={needsToBeRatedSample}
      />

      <ProductCollectionItemCardLoad
        productVariant={productVariant}
        price={price}
        variantId={variantId}
      />

      <ProductCollectionItemLoadFullSizeConversion
        shouldShowFullSizeConversion={shouldShowFullSizeConversion}
        variantId={featuredProductVariant?.fullsize_variant_id}
      />

      <ProductVariantCarouselInfo
        productVariant={productVariant}
        featuredProductVariant={featuredProductVariant}
        isFullSize={isFullSize}
        price={price}
        rating={productVariant.review_info?.rating}
        ratingCount={productVariant.review_info?.rating_count}
        colorIconUrl={shouldFlattenSamples ? productVariant.color_icon_url : false}
        colorOption={shouldFlattenSamples ? productVariant.color_option : false}
        hasDelivery={props.hasDelivery ?? true}
        showRating
        href={getQuickShopHrefProductVariantUtil(productVariant)}
        isOnlyAtAirshopDiscount={isOnlyAtAirshopDiscount}
        discountPercentage={discountPercentageToPass}
        discountPrice={discountPrice}
        imageUrl={imageUrl}
        selectedVariantImage={productVariantImage}
        onClick={handleClick}
        loyaltyTierName={isSelfGifting ? false : productLoyaltyTierName}
        wasJustDropped={wasJustDropped}
        productSampledCount={productVariant?.product_sampled_count}
        productOrderedCount={productVariant?.product_ordered_count}
        productFavStat={productVariant?.product_fav_stats}
        isRelatedProduct={props?.isRelatedProduct}
        shouldShowFullSizeConversion={shouldShowFullSizeConversion}
        compareAtPrice={compareAtPrice}
        rawPrice={rawPrice}
      />

      <ProductCollectionItemButton {...buttonsProps} />
    </Flex>
  )
}

export default React.memo(ProductCollectionItem)
